const colors = {
  primary: '#ff6a0e',
  primary_dark: '#d75200',
  primary_light: '#ff8c5a',
  primary_lighter: '#fdd3c2',
  secondary: '#6048fd',
  secondary_light: '#e7e3ff',
  secondary_lighter: '#f3f4ff',
  secondary_dark: '#272250',
  secondary_darker: '181532',
  tertiary: '#c08e6b',
  tertiary_light: '#c9b9ad',
  tertiary_lighter: '#fef8f4',
  quaternary: '#ff6363',
  quaternary_dark: '#86242e',
  quaternary_light: '#fc9494',
  quaternary_lighter: '#fbe4e4',
  quinary_dark: '#17547c',
  quinary: '#d5ecfc',
  quinary_light: '#eff2fd',
  quinary_lighter: '#f9fbff',
  neutral_900: '#191d23',
  neutral_800: '#25282c',
  neutral_700: '#2c3138',
  neutral_600: '#4c535d',
  neutral_500: '#505863',
  neutral_400: '#97a5bb',
  neutral_300: '#D9E5F9',
  neutral_200: '#E0EAFA',
  neutral_100: '#EEF4FF',
  neutral_80: '#f5f9ff',
  neutral_60: '#FAFCFF',
  neutral_50: '#FDFEFF',
  neutral_25: '#fff',
  neutral_0: 0xff000000,
  error: '#ff6363',
  success: '#00aeb3',
  warning: '#ffbc2f',
  warning_dark: '#d7a029',
  info: '#22cb3c',
};
export default defineNuxtPlugin(() => {
  return {
    provide: {
      colors,
    },
  };
});
